import { SET_PROFILE} from "../types";
import {IProfileState} from "./IProfileState";

const handlers = {
  [SET_PROFILE]: (state:IProfileState, payload:{payload: any, type: 'SET_PROFILE'}) => ({...state, profile: payload.payload}),
  DEFAULT: (state:any) => state
}

export const profileReducer = (state: IProfileState, action: { type: any, payload?: any }) => {
  // @ts-ignore
  const handle = handlers[action.type] || handlers.DEFAULT
  return handle(state, action)
}
